"use client";

import { c as _c } from "react/compiler-runtime";
import { faSearch, faSquareXmark, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { formatAddress } from "@/helpers/Helpers";
import styles from "./SearchModal.module.scss";
interface Props {
  show: boolean;
  setShow(show: boolean): any;
  searchWallets: string[];
  addSearchWallet(wallet: string): any;
  removeSearchWallet(wallet: string): any;
  clearSearchWallets(): any;
}
function SearchModal(props) {
  const $ = _c(39);
  const [invalidWalletAdded, setInvalidWalletAdded] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  let t0;
  if ($[0] !== props || $[1] !== searchValue) {
    t0 = function addSearchWallet() {
      if (!props.searchWallets.some(sw => sw === searchValue)) {
        props.addSearchWallet(searchValue);
        setSearchValue("");
      } else {
        setInvalidWalletAdded(true);
        setTimeout(() => {
          setInvalidWalletAdded(false);
        }, 200);
      }
    };
    $[0] = props;
    $[1] = searchValue;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const addSearchWallet = t0;
  const t1 = props.show;
  let t2;
  if ($[3] !== props) {
    t2 = () => props.setShow(false);
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Modal.Header><Modal.Title>Search</Modal.Title></Modal.Header>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${invalidWalletAdded ? styles.shakeWalletInput : ""} mb-3`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => setSearchValue(e.target.value);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== addSearchWallet) {
    t6 = target => {
      if (target.key === "Enter") {
        addSearchWallet();
      }
    };
    $[7] = addSearchWallet;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== searchValue || $[10] !== t6) {
    t7 = <Form.Control value={searchValue} onChange={t5} onKeyDown={t6} autoFocus={true} className={`${styles.modalInput}`} placeholder="Search for address, ENS or username" />;
    $[9] = searchValue;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== addSearchWallet) {
    t8 = <Button className={styles.modalButton} onClick={addSearchWallet} aria-label="Add search wallet">+</Button>;
    $[12] = addSearchWallet;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t7 || $[16] !== t8) {
    t9 = <InputGroup className={t4}>{t7}{t8}</InputGroup>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== props) {
    t10 = props.searchWallets.map(w => <div key={w} className="pt-1 pb-1"><><FontAwesomeIcon onClick={() => {
          props.removeSearchWallet(w);
        }} className={styles.removeWalletBtn} icon={faSquareXmark} data-tooltip-id={`remove-wallet-${w}`} /><Tooltip id={`remove-wallet-${w}`} place="top" delayShow={250} style={{
          backgroundColor: "#1F2937",
          color: "white",
          padding: "4px 8px"
        }}>Clear</Tooltip></>{"  "}{w}</div>);
    $[18] = props;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props.searchWallets.length) {
    t11 = props.searchWallets.length === 0 && <div className={styles.noSearchWalletsText}>No search queries added</div>;
    $[20] = props.searchWallets.length;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = props.searchWallets.length === 0;
  let t13;
  if ($[22] !== props) {
    t13 = () => props.clearSearchWallets();
    $[22] = props;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <Button disabled={t12} className={`${styles.modalButtonClear} mt-3 mb-2`} onClick={t13}>Clear All</Button>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== props) {
    t15 = <Button className={`${styles.modalButtonDone} mt-3 mb-2`} onClick={() => props.setShow(false)}>Done</Button>;
    $[27] = props;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t14 || $[32] !== t15 || $[33] !== t9) {
    t16 = <Modal.Body>{t9}{t10}{t11}{t14}{t15}</Modal.Body>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t14;
    $[32] = t15;
    $[33] = t9;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== props.show || $[36] !== t16 || $[37] !== t2) {
    t17 = <Modal show={t1} centered={true} onHide={t2}>{t3}{t16}</Modal>;
    $[35] = props.show;
    $[36] = t16;
    $[37] = t2;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
}
export function SearchWalletsDisplay(props) {
  const $ = _c(16);
  const {
    searchWallets,
    setSearchWallets,
    setShowSearchModal
  } = props;
  let t0;
  if ($[0] !== searchWallets || $[1] !== setSearchWallets) {
    t0 = searchWallets.length > 0 && searchWallets.map(sw => <span className={styles.searchWalletDisplayWrapper} key={sw}><><button className={`btn-link ${styles.searchWalletDisplayBtn}`} onClick={() => setSearchWallets(searchWallets.filter(s => s != sw))} data-tooltip-id={`clear-wallet-display-${sw}`}>x</button><Tooltip id={`clear-wallet-display-${sw}`} place="top" delayShow={250} style={{
          backgroundColor: "#f8f9fa",
          color: "#212529",
          padding: "4px 8px"
        }}>Clear</Tooltip></><span className={styles.searchWalletDisplay}>{sw.endsWith(".eth") ? sw : formatAddress(sw)}</span></span>);
    $[0] = searchWallets;
    $[1] = setSearchWallets;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== searchWallets.length || $[4] !== setSearchWallets) {
    t1 = searchWallets.length > 0 && <><FontAwesomeIcon onClick={() => setSearchWallets([])} className={styles.clearSearchBtnIcon} icon={faTimesCircle} data-tooltip-id="clear-all-display" /><Tooltip id="clear-all-display" place="top" delayShow={250} style={{
        backgroundColor: "#f8f9fa",
        color: "#212529",
        padding: "4px 8px"
      }}>Clear All</Tooltip></>;
    $[3] = searchWallets.length;
    $[4] = setSearchWallets;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== setShowSearchModal) {
    t2 = () => setShowSearchModal(true);
    $[6] = setShowSearchModal;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = `btn-link ${styles.searchBtn} ${searchWallets.length > 0 ? styles.searchBtnActive : ""} d-inline-flex align-items-center justify-content-center`;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FontAwesomeIcon style={{
      width: "20px",
      height: "20px",
      color: "#000"
    }} icon={faSearch} />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3) {
    t5 = <button onClick={t2} className={t3}>{t4}</button>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t5) {
    t6 = <span className="d-flex flex-wrap align-items-center justify-content-end">{t0}{t1}{t5}</span>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export function SearchModalDisplay(props) {
  const $ = _c(13);
  const {
    show,
    setShow,
    searchWallets,
    setSearchWallets
  } = props;
  let t0;
  let t1;
  if ($[0] !== searchWallets || $[1] !== setSearchWallets) {
    t0 = function (newW) {
      setSearchWallets([...searchWallets, newW]);
    };
    t1 = function (removeW) {
      setSearchWallets([...searchWallets].filter(sw => sw != removeW));
    };
    $[0] = searchWallets;
    $[1] = setSearchWallets;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== setSearchWallets) {
    t2 = function () {
      setSearchWallets([]);
    };
    $[4] = setSearchWallets;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== searchWallets || $[7] !== setShow || $[8] !== show || $[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = <SearchModal show={show} searchWallets={searchWallets} setShow={setShow} addSearchWallet={t0} removeSearchWallet={t1} clearSearchWallets={t2} />;
    $[6] = searchWallets;
    $[7] = setShow;
    $[8] = show;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}